module.exports = __webpack_public_path__ + "img/black.e2717523.svg";